// --------------------------------------------------------------------------
// #97 – ASK DOCUMENT MODULE
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var ModalDisplay = require('./modal');
var modalDisplay = new ModalDisplay();

module.exports = function (options) {
    var context = options.context;
    var externalExists = false;

    function init() {
        if (!externalExists) {
            externalExists = true;
            modalDisplay.externalModal(context, context.find('#tools-block-modal'), 'tools');
        }

        if (window.location.hash === '#tools-block-modal') {
            context.find('.info').trigger('click');
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/tools-block.js
// module id = 199
// module chunks = 0